export default {"src":"/_next/static/media/external-penetration-testing.bc268db9.svg","height":370,"width":462,"blurWidth":0,"blurHeight":0};